import QuestionMarkHover from './question-mark-hover';

export default QuestionMarkHover;
